/*
 * @Date: 2023-07-26 14:01:13
 * @LastEditors: wuyanfeiying
 * @desc: 全局 按模块 状态管理
 */
import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth.js'
import whiteList from './whiteList.js'
import infoCollector from './infoCollector.js'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    whiteList,
    infoCollector
  },

  state: {
    // 存储token
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
    loginDate: localStorage.getItem('loginDate') ? localStorage.getItem('loginDate') : '',
    userName: localStorage.getItem('userName') ? localStorage.getItem('userName') : '',
    matchMedia: 'isDesktop', // 桌面端 isDesktop / 移动端 isMobile
    curScreenSize: 'xl'
  },

  getters: {
    // 是否为移动端
    isMobile (state) {
      return state.matchMedia === 'isMobile'
    },
    // 小于XL
    screenMinXL (state) {
      return state.curScreenSize !== 'xl'
    },
    // 小于lg
    screenMinLG (state) {
      return state.curScreenSize === 'md' || state.curScreenSize === 'sm' || state.curScreenSize === 'xs'
    },
    // 小于 md
    screenMinMd (state) {
      return state.curScreenSize === 'sm' || state.curScreenSize === 'xs'
    },
    // 小于 sm
    screenMinSM (state) {
      return state.curScreenSize === 'xs'
    }
  },

  mutations: {
    // 修改token，并将token存入localStorage
    changeLogin (state, user) {
      state.Authorization = user.Authorization
      localStorage.setItem('Authorization', user.Authorization)
      if (user.Authorization) {
        state.loginDate = user.loginDate
        localStorage.setItem('loginDate', user.loginDate)
      }
      if (user.userName) {
        state.userName = user.userName
        localStorage.setItem('userName', user.userName)
      }
    },

    // 当前是 桌面端还是移动端
    updateMatchMedia (state, payload) {
      if (payload && payload !== '') {
        state.matchMedia = payload
      }
    },

    // 更新当前的响应式标识
    updateScreenSize (state, payload) {
      if (payload && payload !== '') {
        state.curScreenSize = payload
      }
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js